'use strict';

import SourceReportsTile from "./components/SourceReportsTile";
import AlleleFrequenciesTile from "./components/AlleleFrequenciesTile";
import LiteratureTable from "./components/LiteratureTable";
import SilicoPredTile from "./components/insilicopred/SilicoPredTile";
import FunctionalAssayTile from "./components/functionalassay/FunctionalAssayTile";
import ComputationalPredictionTile from "./components/computationalprediction/ComputationalPredictionTile";
import ProvisionalEvidenceTile from "./components/ProvisionalEvidenceTile";
import MupitStructure from './MupitStructure';

import './favicons';
import React from 'react';
import { createRoot } from 'react-dom/client';
import DisclaimerModal from './DisclaimerModal';
import RawHTML from './RawHTML';

// Keep your existing CSS includes
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
//import 'css/bootstrap-xlgrid.css'; // adds xl, xxl, xxxl grid sizes to bootstrap 3
import 'css/custom.css';

import _ from 'underscore';
import backend from './backend';
import NavBarNew from './NavBarNew';
// RxJS 6+ imports
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
var moment = require('moment');
import DonationBar from './components/DonationBar';

// masonry/isotope
var Isotope = require('isotope-layout');
require('isotope-packery');
import debounce from 'lodash/debounce';

var brcaLogo = require('./img/BRCA-Exchange-tall-tranparent.png');
var logos = require('./logos');
var slugify = require('./slugify');

import content, {parseTooltips} from './content';
import Community from './Community';
import FactSheet from './FactSheet';
import WhyDonate from './WhyDonate';
import FundraisingDetails from './FundraisingDetails';
import {Splicing} from'./Splicing';
import { withRouter, BrowserRouter, Switch, Route, Link } from 'react-router-dom';

var databaseKey = require('../databaseKey');
var util = require('./util');

// React-Bootstrap v2+ imports (Bootstrap 5)
import { Container as Grid, Col, Row, Table, Button, Modal, Card, Collapse } from 'react-bootstrap';

/* FAISAL: added 'groups' collection that specifies how to map columns to higher-level groups */
import {VariantTable, ResearchVariantTable, researchModeColumns, columns, researchModeGroups, expertModeGroups} from './VariantTable';
import Signup from './Signup';
import {Signin, ResetPassword} from './Signin';
import {ConfirmEmail} from './ConfirmEmail';
import {ChangePassword} from './ChangePassword';
import {Profile} from './Profile';
import VariantSearch from './VariantSearch';
import { Releases, Release } from './Releases.js';
import Help from './Help.js';
import Resources from './Resources.js';

import KeyInline from './components/KeyInline';
import GroupHelpButton from './components/GroupHelpButton';

var variantPathJoin = row => _.map(databaseKey, k => encodeURIComponent(row[k])).join('@@');

if (typeof console === "undefined") {
    window.console = {
        log: function () {}
    };
}

function isEmptyVal(val) {
    if ((typeof val === 'string' || val instanceof String) && val.trim() === '') {
            return true;
        } else if (val === null || val === undefined) {
            return true;
        } else {
            return false;
        }
}

function clean(obj) {
    // Removes all empty values from object.
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
        let propName = propNames[i];
        let val = obj[propName];
        if (isEmptyVal(val)) {
            delete obj[propName];
        }
    }
}

class Footer extends React.PureComponent {
    render() {
        return (
            <div className="container footer">
		<div className = "row">
                    <div className="col-sm-5 left-footer">
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/about/history">About</a></li>
                        <li><a href="/variants">Variants</a></li>
			<li><a href="/resources">Resources</a></li>
                        <li><a href="/about/api">API</a></li>
                        <li><a href="https://brcaexchange.org/blog">Blog</a></li>
                    </ul>
                    </div>
                    <div className="col-sm-2 logo-footer">
                        <img src={brcaLogo} alt="brca exchange logo" />
                    </div>
                    <div className="col-sm-5 right-footer">
                    <ul>
                        <li>
                            <a href="/whydonate">Donate</a>
                        </li>
                        <li>
                            <DisclaimerModal text="Disclaimer"/>
                        </li>
                        <li>
                            <a href="https://github.com/BRCAChallenge/brca-exchange">
                                Source code
                            </a>
                        </li>
                        <li>
                            <a href="mailto:brcaexchange@gmail.com?subject=BRCA Exchange website">
                                Contact us
                            </a>
                        </li>
                        <li><a href="/help">Help</a></li>
                    </ul>
                    </div>
		</div>
            </div>
        );
    }
}

class HomeRaw extends React.Component {
    constructor(props) {
        super(props);
	this.state = {
            index: 0,
            direction: null,
            showModal: false
        };
	this.onSearch = this.onSearch.bind(this);
    }
    onSearch(value) {
	const query = value ? `?search=${encodeURIComponent(value)}` : '';
        this.props.history.push(`/variants${query}`);
    }
    render() {
        let currentSupporters = _.filter(logos, function(logo) {
                                    return logo.currentSupporter;
                                });
        let notCurrentSupporterLogos = _.filter(logos, function(logo) {
                             return !logo.currentSupporter;
                         });
        var notCurrentSupporterLogoItems = _.map(notCurrentSupporterLogos, ({id, logo, url}) => (
            <Col key={id} lg={4} md={6} xs={12} className="logo-item">
                <a href={url}>
                    <img id={id} src={logo} alt={id + ' logo'} />
                </a>
            </Col>
        ));
        var currentSupporterLogoItems = _.map(currentSupporters, ({id, logo, url}) => (
            <Col key={id} lg={4} md={6} xs={12} className="logo-item">
                <a href={url}>
                    <img id={id} src={logo} alt={id + ' logo'} />
                </a>
            </Col>
        ));
        return (
            <Grid id="main-grid" className='home'>
                <Row>
                    <Col sm={{ span: 8, offset: 2 }}>
			<h2 style={{fontWeight: 'bold'}}>
                            Search for your BRCA variant of interest:
                        </h2>
                       <VariantSearch
                           id='home-search'
                           onSearch={this.onSearch}/>
                    </Col>
                </Row>
		<Row>
		   <h3>
			Find educational and support information on our <Link to={'/resources'}>Resources</Link> page.
		   </h3>
		</Row>
                <Row>
                    <div className="jumbotron homepage-jumbotron">
                        <RawHTML html={content.pages.home} />
                    </div>
                </Row>

                <Row>
                    <Col lg={{ span: 4, offset: 1 }} md={{ span: 8, offset: 2 }} xs={12}>
                        <div className="ratio ratio-16x9">
                            <iframe className="vimeo-video" src="https://player.vimeo.com/video/199396428" allowFullScreen />
                        </div>
                        <div className="homepage-under-image-text-container center-block">
                            <div className="homepage-caption">
                            What is the BRCA Exchange?
                            </div>
                            <div className="homepage-caption subtext">
                            Video produced by <a href="http://www.kindealabs.com/">Kindea Labs</a>
                            </div>
                        </div>
                    </Col>

                    <Col lg={{ span: 4, offset: 2 }} md={{ span: 8, offset: 2 }} xs={12}>
                        <div className="ratio ratio-16x9">
                            <iframe className="vimeo-video" src="https://player.vimeo.com/video/351028818" allowFullScreen />
                        </div>
                        <div className="homepage-under-image-text-container center-block">
                            <div className="homepage-caption">
                                How Does the BRCA Exchange Benefit Patients?
                            </div>
                            <div className="homepage-caption subtext">
                                Video produced by the <a href="https://www.ga4gh.org/">Global Alliance for Genomics and Health</a> and the <a href="https://www.broadinstitute.org/">Broad Institute</a>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="logo-block">
                    {notCurrentSupporterLogoItems}
                </Row>
                <Row className="logo-block">
                    {currentSupporterLogoItems.length ? (<h3 className="logo-header">Currently Supported By:</h3>) : '' }
                    {currentSupporterLogoItems}
                </Row>
                <Row className="logo-block">
                    <h3 className="logo-header no-margin-bottom">Consider supporting this open-source project by <Link to={'/whydonate'}>donating</Link> today.</h3>
                </Row>
            </Grid>
        );
    }
}
const Home = withRouter(HomeRaw);

class About extends React.Component {
    render() {
        const { page } =
		(this.props.match && this.props.match.params) ||
 	      	this.props.params ||
		{};
	if (page === "thisSite") {
            let currentSupporters = _.filter(logos, function(logo) {
                                        return logo.currentSupporter;
                                    });
            let notCurrentSupporterLogos = _.filter(logos, function(logo) {
                                 return !logo.currentSupporter;
                             });
            var notCurrentSupporterLogoItems = _.map(notCurrentSupporterLogos, ({id, logo, url}) => (
                <Col key={id} lg={4} md={6} xs={12} className="logo-item">
                    <a href={url}>
                        <img id={id} src={logo} alt={id + ' logo'} />
                    </a>
                </Col>
            ));
            var currentSupporterLogoItems = _.map(currentSupporters, ({id, logo, url}) => (
                <Col key={id} lg={4} md={6} xs={12} className="logo-item">
                    <a href={url}>
                        <img id={id} src={logo} alt={id + ' logo'} />
                    </a>
                </Col>
            ));
            return (
                <Grid id="main-grid" className="main-grid">
                    <Row>
                        <Col sm={{ span: 10, offset: 1 }}>
                            <RawHTML html={content.pages[page]} />
                        </Col>
                    </Row>
                    <Row className="logo-block">
                        {notCurrentSupporterLogoItems}
                    </Row>
                    <Row className="logo-block">
                        {currentSupporterLogoItems.length ? (<h3 className="logo-header">Currently Supported By:</h3>) : '' }
                        {currentSupporterLogoItems}
                    </Row>
                </Grid>
            );
        } else {
            return (
                <Grid id="main-grid" className="main-grid">
                    <Row>
                        <Col sm={{ span: 10, offset: 1 }}>
                            <RawHTML html={content.pages[page]} />
                        </Col>
                    </Row>
                </Grid>
            );
        }
    }
}

function toNumber(v) {
    return _.isString(v) ? parseInt(v) : v;
}

function databaseParams(paramsIn) {
    var {filter, filterValue, hide, hideSources, excludeSources, orderBy, order, search = '', changeTypes} = paramsIn;

    const asArray = (v) => {
        if (v === null || v === undefined) return [];
        if (Array.isArray(v)) return v;
        if (typeof v === 'string') return v.length ? [v] : [];
        return [v];
    };

    filter = asArray(filter);
    filterValue = asArray(filterValue);
    hide = asArray(hide);
    hideSources = asArray(hideSources);
    excludeSources = asArray(excludeSources);
    changeTypes = asArray(changeTypes);
    var numParams = _.mapObject(_.pick(paramsIn, 'page', 'pageLength', 'release'), toNumber);
    var sortBy = {prop: orderBy, order};
    var columnSelection = _.object(hide, _.map(hide, _.constant(false)));
    var sourceSelection = {..._.object(hideSources, _.map(hideSources, _.constant(0))),
                           ..._.object(excludeSources, _.map(excludeSources, _.constant(-1)))};
    var filterValues = _.object(filter, filterValue);
    return {changeTypes, search, sortBy, columnSelection, sourceSelection, filterValues, hide, ...numParams};
}

var transpose = a => _.zip.apply(_, a);

function urlFromDatabase(state) {
    let {release, changeTypes, columnSelection, filterValues, sourceSelection,
         search, page, pageLength, mode, sortBy: {prop, order}} = state;
    if (mode !== "default") {
        // Default mode (expert portal) has static columns/sources.
        var hide = _.keys(_.pick(columnSelection, v => v === false));
        var hideSources = _.keys(_.pick(sourceSelection, v => v === 0));
        var excludeSources = _.keys(_.pick(sourceSelection, v => v === -1));
    } else {
        hide = '';
        hideSources = '';
        excludeSources = '';
    }
    // Remove empty values from filterValues.
    clean(filterValues);
    let [filter, filterValue] = transpose(_.pairs(filterValues, v => (v !== null && v !== undefined && v !== '')));
    return _.pick({
        release,
        changeTypes,
        search: search === '' ? null : backend.trimSearchTerm(search),
        filter,
        filterValue,
        page: page === 0 ? null : page,
        pageLength: pageLength === 20 ? null : pageLength,
        orderBy: prop,
        order,
        hideSources: hideSources,
        excludeSources: excludeSources,
        hide: hide.length === 0 ? null : hide
    }, v => (!isEmptyVal(v)));

}

class Database extends React.Component {
    // Note this is not a pure component because of the calls to
    // getQuery().
    constructor(props) {
        super(props);
        this.state = { showModal: false, restoringDefaults: false };
	this.tableRef = React.createRef();
        this.showVariant = this.showVariant.bind(this);
        this.showHelp = this.showHelp.bind(this);
        this.onChange = this.onChange.bind(this);
        this.restoreDefaults = this.restoreDefaults.bind(this);
        this.toggleMode = this.toggleMode.bind(this);
    }

    // replacement for react-router State mixin getQuery()
    getQuery() {
        const search = (this.props.location && this.props.location.search) || '';
        const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
        const out = {};
        params.forEach((v, k) => {
            // preserve repeated keys as arrays
            if (Object.prototype.hasOwnProperty.call(out, k)) {
                out[k] = Array.isArray(out[k]) ? out[k].concat(v) : [out[k], v];
            } else {
                out[k] = v;
            }
        });
        return out;
    }

    // replacement for react-router Navigation mixin transitionTo()
    transitionTo(path, _params, query) { // _params kept for callsite compatibility
        let search = '';
        if (query && Object.keys(query).length) {
	const sp = new URLSearchParams();
            Object.entries(query).forEach(([k, v]) => {
                if (v === undefined || v === null) return;
                if (Array.isArray(v)) v.forEach(x => sp.append(k, String(x)));
                else sp.set(k, String(v));
            });
            const qs = sp.toString();
            search = qs ? `?${qs}` : '';
        }

        // support history/router injection patterns
        const router = this.props.router || this.props.history || (this.context && this.context.router);
        const nextLoc = { pathname: path, search };

        if (router) {
            if (typeof router.push === 'function') return router.push(nextLoc);
            if (typeof router.transitionTo === 'function') return router.transitionTo(path, _params, query);
        }

        // last resort
        window.location.assign(path + search);
    }

    showVariant(row, event) {
          var d3TipDiv = document.getElementsByClassName('d3-tip-selection');
          if (d3TipDiv.length !== 0 && d3TipDiv[0].style.opacity !== '0') {
              d3TipDiv[0].style.opacity = '0';
              d3TipDiv[0].style.pointerEvents = 'none';
          }

          if (event.metaKey || event.altKey || event.ctrlKey || event.button === 1) {
              // the user is attempting to open the link in a new window/tab
              // (browsers vary in what they consider the 'special' tab-opening key, so we're trapping for them all)
              window.open(`/variant/${variantPathJoin(row)}`, '_blank');
          }
          else {
              // open it in the current window
              this.transitionTo(`/variant/${variantPathJoin(row)}`);
          }
    }

    // TODO: use `title` to link to a section-specific help page instead of the generic /help route
    showHelp(_title) {
        var d3TipDiv = document.getElementsByClassName('d3-tip-selection');
        if (d3TipDiv.length !== 0 && d3TipDiv[0].style.opacity !== '0') {
            d3TipDiv[0].style.opacity = '0';
            d3TipDiv[0].style.pointerEvents = 'none';
        }
        this.transitionTo(`/help`);
    }

    componentDidMount() {
        this.urlq = new Subject();
        this.subs = this.urlq.pipe(debounceTime(500)).subscribe(this.onChange);
    }

    componentWillUnmount() {
        if (this.subs) this.subs.unsubscribe();
    }

    restoreDefaults(callback) {
        this.setState({restoringDefaults: true}, () => {
            this.transitionTo('/variants');

            // Callback resets filters in DataTable.
            // HACK: wrapped in setTimeout to ensure that it happens
            // after transitionTo is complete.
            setTimeout(callback, 0);
        });
    }

	// XXX An oddity of the state flow here: we update the url when table settings
	// change, so the page can be bookmarked, and forward/back buttons work. We
	// do it on a timeout so we don't generate history entries for every keystroke,
	// which would be bad for the user. Changing the url causes a re-render, passing
	// in new props, which causes DataTable to overwrite its state with the
	// same state that caused us to update the url. It's a bit circular.
	// It would be less confusing if DataTable did not hold these params in state,
	// but just read them from props, and all updates to the props occurred via
	// transitionTo(). Consider for a later refactor.

    onChange(state) {
        if (this.props.show) {
            var d3TipDiv = document.getElementsByClassName('d3-tip-selection');
            if (d3TipDiv.length !== 0 && d3TipDiv[0].style.opacity !== '0') {
                d3TipDiv[0].style.opacity = '0';
                d3TipDiv[0].style.pointerEvents = 'none';
            }
            if (!this.state.showModal && !this.state.restoringDefaults) {
                this.transitionTo('/variants', {}, urlFromDatabase(state));
            } else if (this.state.restoringDefaults) {
                this.setState({restoringDefaults: false});
            }
        }
    }

    toggleMode() {
        this.props.toggleMode();
        this.setState({ showModal: false });
    }

    render() {
        var {show} = this.props,
            params = databaseParams(this.getQuery());
        var table, message;
        if (this.state.restoringDefaults) {
            params.columnSelection = {};
            params.sourceSelection = {};
            params.filterValues = {};
        }
        if (this.props.mode === 'research_mode') {
            table = (
				<ResearchVariantTable
					ref={this.tableRef}
					initialState={params}
					{...params}
					fetch={backend.data}
					url={backend.url}
					onChange={s => this.urlq.next(s)}
					onToggleMode={this}
					keys={databaseKey}
					onHeaderClick={this.showHelp}
					onRowClick={this.showVariant}
                    restoreDefaults={this.restoreDefaults}
                    mode={this.props.mode}/>);
            message = this.renderMessage(content.pages.variantsResearch);
        } else {
            // Always reset column and source selections to default in expert mode.
            params.columnSelection = {};
            params.sourceSelection = {};
            table = (
				<VariantTable
					ref={this.tableRef}
					initialState={params}
					{...params}
					fetch={backend.data}
					url={backend.url}
					onChange={s => this.urlq.next(s)}
					onToggleMode={this}
					keys={databaseKey}
					onHeaderClick={this.showHelp}
					onRowClick={this.showVariant}
                    restoreDefaults={this.restoreDefaults}
                    mode={this.props.mode}/>);
            message = this.renderMessage(content.pages.variantsDefault);
        }
        return (
            <Grid id="main-grid" style={{display: show ? 'block' : 'none'}}>
                {message}
                {table}
            </Grid>
        );
    }

    renderMessage(message) {
        return  (
			<Row>
				<Col className="jumbotron colorized-jumbo">
					{this.props.mode === 'default' && <img id='enigma-logo' src={require('./img/enigma_logo.jpeg')} />}
					<RawHTML html={message}/>
					{this.props.mode === 'research_mode' && <Button variant="secondary" onClick={this.toggleMode}>
						Show Summary Data Only
					</Button>}
					{this.props.mode === 'default' &&
					<Button variant="secondary" onClick={() =>this.setState({showModal: true})}>
						Show Detail View
					</Button>}
					{
					    this.props.mode === 'default' && this.state.showModal &&
                        <Modal show={true} onHide={() => this.setState({ showModal: false })}>
                            <Modal.Body>
                                <RawHTML html={content.pages.researchWarning}/>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={() => {this.toggleMode();}}>Yes</Button>
                                <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>No</Button>
                            </Modal.Footer>
                        </Modal>
					}
				</Col>
			</Row>);
    }
}

// get display name for a given key from VariantTable.js column specification
// if we are in summary view mode, search summary view names then fall back to
// all data, otherwise go straight to all data. Finally, if key is not found, replace
// _ with space in the key and return that.
function getDisplayName(key) {
    const researchMode = (localStorage.getItem("research-mode") === 'true');
    let displayName;
    if (!researchMode) {
        displayName = columns.find(e => e.prop === key);
        displayName = displayName && displayName.title;
    }
    if (displayName === undefined) {
        displayName = researchModeColumns.find(e => e.prop === key);
        displayName = displayName && displayName.title;
    }
    if (displayName === undefined) {
        displayName = key.replace(/_/g, " ");
    }
    return displayName;
}

function isEmptyDiff(value) {
    return value === null || value.length < 1;
}

class IsoGrid extends React.Component {
    static displayName = 'IsoGrid';

    constructor(props) {
	super(props);
	this._rootRef = React.createRef();
	this.masonry = null;
    }

    render() {
        return (
            <div className="isogrid" ref={this._rootRef}>
            {this.props.children}
            </div>
        );
    }

    componentDidMount() {
        const root = this._rootRef.current;
	if (!root || !this.masonry) {
            this.masonry = new Isotope(root, {
                layoutMode: 'packery',
                itemSelector: '.isogrid-item',
                packery: {
                    columnWidth: '.isogrid-sizer',
                    gutter: 0
                }
            });
        }
    }

    componentWillUnmount() {
	// prevent leaks / dangling observers
	if (this.masonry && typeof this.masonry.destroy === 'function') {
	    this.masonry.destroy();
	}
	this.masonry = null;
    }

    relayout(fullRefresh) {
        if (!this.masonry) {
            return;
        }
        if (fullRefresh) {
            this.masonry.reloadItems();
        }
        this.masonry.arrange();
    }
}

// Helpers for new Card/Collapse behavior
function isOpenFromStorage(key) {
    // legacy semantics: localStorage "true" means collapsed
    return localStorage.getItem(key) !== "true";
}

class VariantDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hideEmptyItems: (localStorage.getItem("hide-empties") === 'true'),
            tooltips: parseTooltips(localStorage.getItem("research-mode") === 'true'),
            // track open/closed state for cards (keyed by localStorage key)
            openGroups: {}
        };

        // bind methods passed as callbacks / props
        this.showHelp = this.showHelp.bind(this);
        this.relayoutOnCollapsed = this.relayoutOnCollapsed.bind(this);
        this.onChangeGroupVisibility = this.onChangeGroupVisibility.bind(this);
        this.isGroupOpenLS = this.isGroupOpenLS.bind(this);
        this.toggleCard = this.toggleCard.bind(this);
        this.setEmptyRowVisibility = this.setEmptyRowVisibility.bind(this);
        this.determineDiffRowColor = this.determineDiffRowColor.bind(this);
        this.getPathogenicity = this.getPathogenicity.bind(this);
        this.generateDiffRows = this.generateDiffRows.bind(this);
        this.toggleSubmitterGroup = this.toggleSubmitterGroup.bind(this);

        // debounce relayout (same behavior as before)
        this.relayoutGrid = debounce((fullRefresh) => {
            if (this.isogrid) this.isogrid.relayout(fullRefresh);
        }, 100);

        this._subs = [];
    }

    // ---- router helpers (replace Navigation/State mixins) ----
    getParamId() {
        return (
            (this.props.params && this.props.params.id) ||
            (this.props.match && this.props.match.params && this.props.match.params.id)
        );
    }

    getQuery() {
        const search = (this.props.location && this.props.location.search) || '';
        const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
        const out = {};
        params.forEach((v, k) => {
            if (Object.prototype.hasOwnProperty.call(out, k)) {
                out[k] = Array.isArray(out[k]) ? out[k].concat(v) : [out[k], v];
            } else {
                out[k] = v;
            }
        });
        return out;
    }

    buildURL(path, query) {
        if (!query || !Object.keys(query).length) return path;
        const [base, hash = ''] = path.split('#', 2);
        const sp = new URLSearchParams();
        Object.entries(query).forEach(([k, v]) => {
            if (v === undefined || v === null) return;
            if (Array.isArray(v)) v.forEach(x => sp.append(k, String(x)));
            else sp.set(k, String(v));
        });
        const qs = sp.toString();
        return base + (qs ? `?${qs}` : '') + (hash ? `#${hash}` : '');
    }

    transitionTo(path, _params, query) {
        const url = this.buildURL(path, query);
        const router = this.props.router || this.props.history || (this.context && this.context.router);
        if (router) {
            if (typeof router.push === 'function') return router.push(url);
            if (typeof router.transitionTo === 'function') return router.transitionTo(path, _params, query);
        }
        window.location.assign(url);
    }

    replaceWith(pathTemplate, params, query) {
        const path = params && params.id
            ? pathTemplate.replace(':id', params.id)
            : pathTemplate;
        const url = this.buildURL(path, query);
        const router = this.props.router || this.props.history || (this.context && this.context.router);
        if (router) {
            if (typeof router.replace === 'function') return router.replace(url);
            if (typeof router.replaceWith === 'function') return router.replaceWith(pathTemplate, params, query);
        }
        window.location.replace(url);
    }

    showHelp(event, title) {
        event.preventDefault();
        this.transitionTo(`/help#${slugify(title)}`);
    }

    componentDidMount() {
        const id = this.getParamId();

	this._subs.push(
	    backend.variant(id).subscribe(
            resp => {
                if (Object.prototype.hasOwnProperty.call(resp, 'redirect') && resp.redirect === true) {
                    this.transitionTo('/variants', null, {search: resp.data});
                } else {
                    this.setState({data: resp.data, error: null});
                }
            },
            () => { this.setState({error: 'Problem connecting to server'}); }
	    )
        );

        this._subs.push(
            backend.variantReports(id).subscribe(
	    resp => {
                const groupedReports = _.groupBy(resp.data, 'Source');
                this.setState({reports: groupedReports, error: null}, () => {
                    this.relayoutGrid();
                });
            },
	    () => {
                this.setState({reportError: 'Problem retrieving reports'});
                console.warn("Couldn't retrieve reports!");
            }
	    )
        );

    }

    componentWillUnmount() {
        this._subs.forEach(s => s && typeof s.unsubscribe === 'function' && s.unsubscribe());
        if (this.relayoutGrid && this.relayoutGrid.cancel) this.relayoutGrid.cancel();
    }

    componentDidUpdate(prevProps, prevState) {
        // mode change => refresh tooltips + relayout
        if (prevProps.mode !== this.props.mode) {
            console.log('VariantDetail mode changed from', prevProps.mode, 'to', this.props.mode);
	    this.setState({ tooltips: parseTooltips(this.props.mode === 'research_mode') });
            setTimeout(() => this.relayoutGrid(true), 0);
        }

        // ensure that we're viewing the latest version of the variant, with the stable CA_ID URL.
	// and redirect if we're not,
	// unless the querystring param 'noRedirect=true' is specified, in which case we stay here.
	// In the rare case there is no CA_ID, redirect to the latest version by numeric ID instead.
	// (if someone *really* wants to link to the old variant, they may also specify 'noRedirectMsg=true'
	// to silence the warning at the top of the page, too.)
	// redirect logic (moved from componentWillUpdate)
        const { data } = this.state;
        const currentId = this.getParamId();
        if (data && data[0] && currentId !== data[0].CA_ID) {
            const { noRedirect } = this.getQuery();
            if (noRedirect !== "true") {
                const redirectToID = data[0].CA_ID || data[0].id;
                if (parseInt(currentId) === data[0].id) {
                    this.replaceWith(`/variant/:id`, { id: redirectToID }, {});
                } else if (!prevState.data || prevState.data !== data || prevProps.params?.id !== currentId) {
                    this.replaceWith(`/variant/:id`, { id: redirectToID }, { redirectedFrom: currentId });
                }
            }
        }

        // set document title once data arrives
        if (!prevState.data && this.state.data) {
            const dataNow = this.state.data;
            const variantVersionIdx = dataNow.findIndex(x => x.id === parseInt(this.getParamId()));
            const variant = dataNow[variantVersionIdx] || dataNow[0];
            document.title = `${variant['HGVS_cDNA'].split(":")[1]} (${variant['Gene_Symbol']}) - BRCA Exchange`;
        }
    }

    pathogenicityChanged(pathogenicityDiff) {
        return (pathogenicityDiff.added || pathogenicityDiff.removed) ? true : false;
    }

    setEmptyRowVisibility(hideEmptyItems) {
        localStorage.setItem('hide-empties', hideEmptyItems);
        this.setState({
            hideEmptyItems: hideEmptyItems
        }, () => {
            this.relayoutGrid();
        });
    }

    truncateData(field) {
        const fieldsToTruncate = ["Genomic_Coordinate_hg38", "Genomic_Coordinate_hg37"];
        if (fieldsToTruncate.indexOf(field) > -1) {
            return true;
        } else {
            return false;
        }
    }

    relayoutOnCollapsed(/* collapser */) {
        console.warn("Deprecated relayoutOnCollapsed; replace relayoutOnCollapsed handlers w/direct calls to relayoutGrid() in your collapsing components");
    }
    // legacy API kept for callers; now just flips storage and local openGroups
    onChangeGroupVisibility(groupTitle, event) {
        event.preventDefault();
        const key = "collapse-group_" + groupTitle;
        const willBeCollapsed = localStorage.getItem(key) !== "true";
        localStorage.setItem(key, willBeCollapsed ? "true" : "false");
        const willBeOpen = !willBeCollapsed;
        this.setState({ openGroups: { ...this.state.openGroups, [key]: willBeOpen } });
    }
    isGroupOpenLS(key) {
        // local state wins, otherwise read from storage (for initial render)
        if (Object.prototype.hasOwnProperty.call(this.state.openGroups, key)) { return !!this.state.openGroups[key]; }
        return isOpenFromStorage(key);
    }
    toggleCard(key) {
       this.setState((prev) => {
       const currentlyOpen =
           Object.prototype.hasOwnProperty.call(prev.openGroups, key)
           ? prev.openGroups[key]
           : (localStorage.getItem(key) !== "true");

       const nowOpen = !currentlyOpen;
       // store "true" when collapsed (legacy semantics)
       localStorage.setItem(key, nowOpen ? "false" : "true");

       console.log('toggleCard:', key, 'was', currentlyOpen, 'now', nowOpen);
       return { openGroups: { ...prev.openGroups, [key]: nowOpen } };
   }, () => {
       // Callback to ensure relayout happens after state update
       console.log('State updated, openGroups:', this.state.openGroups);
       if (this.relayoutGrid) {
           this.relayoutGrid();
       }
   });
    }
    determineDiffRowColor(highlightRow) {
        return highlightRow ? 'table-danger' : '';
    }
    getPathogenicity(version, isReport) {
        if (isReport) {
            if (version.Source === "ClinVar") {
                return util.getFormattedFieldByProp("Clinical_Significance_ClinVar", version);
            } else {
                return util.getFormattedFieldByProp("Classification_LOVD", version);
            }
        } else {
            return util.getFormattedFieldByProp("Pathogenicity_expert", version);
        }
    }
    generateDiffRows(cols, data, isReports) {
        var diffRows = [];
        var relevantFieldsToDisplayChanges = cols.map(function(col) {
            return col.prop;
        });

        for (var i = 0; i < data.length; i++) {
            let version = data[i];
            let diff = version.Diff;
            let release = version.Data_Release;
            let highlightRow = false;
            var diffHTML = [];
            if (diff !== null) {
                for (var j = 0; j < diff.length; j++) {
                    let fieldDiff = diff[j];
                    let fieldName = fieldDiff.field;
                    var added;
                    var removed;

                    if (fieldName === "Pathogenicity_expert") {
                        highlightRow = this.pathogenicityChanged(fieldDiff);
                    }

                    if (!_.contains(relevantFieldsToDisplayChanges, fieldName)) {
                        continue;
                    }

                    if (_.contains(util.dateKeys, fieldName)) {
                        added = util.reformatDate(fieldDiff.added);
                        removed = util.reformatDate(fieldDiff.removed);
                    } else if (fieldDiff.field_type === "list") {
                        added = _.map(fieldDiff.added, elem => elem.replace(/_/g, " ").trim());
                        removed = _.map(fieldDiff.removed, elem => elem.replace(/_/g, " ").trim());
                    } else {
                        added = fieldDiff.added.trim();
                        removed = fieldDiff.removed.trim();
                    }

                    if (fieldName === "Summary_Evidence_ClinVar" || fieldName === "Description_ClinVar" || fieldName === "Review_Status_ClinVar") {
                        added = fieldDiff.added.replace(/_/g, " ").trim();
                        removed = fieldDiff.removed.replace(/_/g, " ").trim();
                    }

                    if (added !== null || removed !== null) {
                        if (util.isEmptyField(removed)) {
                            diffHTML.push(
                                <span key={`diff-${i}-${j}-new`}>
                                    <strong>{ getDisplayName(fieldName) }: </strong>
                                    <span className='badge bg-success'><span className='fa fa-star' /> New</span>
                                    &nbsp;{`${added}`}
                                </span>
                            );
			    diffHTML.push(<br key={`diff-${i}-${j}-br`} />);
                        } else if (fieldDiff.field_type === "list") {
                            diffHTML.push(
                                <span key={`diff-${i}-${j}-list`}>
                                    <strong>{ getDisplayName(fieldName) }: </strong> <br />
                                    { !isEmptyDiff(added) && `+${added}` }{ !!(!isEmptyDiff(added) && !isEmptyDiff(removed)) && ', '}{ !isEmptyDiff(removed) && `-${removed}` }
                                </span>
                            );
			    diffHTML.push(<br key={`diff-${i}-${j}-br`} />);
                        } else if (fieldDiff.field_type === "individual") {
                            diffHTML.push(
                                <span key={`diff-${i}-${j}-individual`}>
                                    <strong>{ getDisplayName(fieldName) }: </strong>
                                    {removed} <span className="fa fa-arrow-right" /> {added}
                                </span>
                            );
			    diffHTML.push(<br key={`diff-${i}-${j}-br`} />);
                        }
                    }
                }
            }

            diffRows.push(
                <tr key={i} className={this.determineDiffRowColor(highlightRow)}>
                    <td><Link to={`/release/${release.id}`}>{moment(release.date, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY")}</Link></td>
                    <td>{this.getPathogenicity(version, isReports)}</td>
                    <td>{diffHTML}</td>
                </tr>
            );
        }

        return diffRows;
    }

    toggleSubmitterGroup(sourceName, submitter) {
        this.setState((pstate) => {
            const k = `submitter-group-${sourceName}-${submitter}`;
            return {
                [k]: !(!Object.prototype.hasOwnProperty.call(pstate, k) || pstate[k])
            };
        });
    }

    // render for VariantDetail
    render() {
        console.log('VariantDetail render, mode prop:', this.props.mode);
	const {data, error} = this.state;
        if (!data) {
            return <div />;
        }

        const variantVersionIdx = data.findIndex(x => x.id === parseInt(this.getParamId()));
        const variant = data[variantVersionIdx] || data[0];
        const release = variant["Data_Release"];
        let cols, groups;

        const { redirectedFrom, noRedirectMsg } = this.getQuery();
        const redirectedFromVariant = redirectedFrom ? data.find(x => x.id === parseInt(redirectedFrom)) : null;

        if (this.props.mode === 'research_mode') {
            cols = researchModeColumns;
            groups = researchModeGroups;
        } else {
            cols = columns;
            groups = expertModeGroups;
        }

        const groupTables = _.map(groups, ({ groupTitle, innerCols, reportSource, reportBinding, alleleFrequencies, inSilicoPred, innerGroups }) => {
            let rowsEmpty = 0;

            if (reportSource) {
                if (!this.state.reports || !this.state.reports[reportSource]) {
                    return null;
                }
                if (!reportBinding) {
                    console.warn("Source report rendering requested for source with missing metadata: ", reportSource);
                    return null;
                }

                return (
                    <SourceReportsTile
                        key={`tile-${groupTitle}`}
                        groupTitle={groupTitle}
                        sourceName={reportSource}
                        reportBinding={reportBinding}
                        submissions={this.state.reports[reportSource]}
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        relayoutGrid={this.relayoutGrid}
                        hideEmptyItems={this.state.hideEmptyItems}
                        helpSection={reportBinding.helpKey}
                        showHelp={this.showHelp}
                        tooltips={this.state.tooltips}
                    />
                );
            }

            if (alleleFrequencies) {
                return (
                    <AlleleFrequenciesTile
                        key={`tile-${groupTitle}`}
                        alleleFrequencyData={innerGroups}
                        groupTitle={groupTitle}
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        relayoutGrid={this.relayoutGrid}
                        hideEmptyItems={this.state.hideEmptyItems}
                        helpSection="allele-frequency-reference-sets"
                        showHelp={this.showHelp}
                        tooltips={this.state.tooltips}
                        variant={variant}
                    />
                );
            }
            if (inSilicoPred) {
                return (
                    <SilicoPredTile
                        key={`tile-${groupTitle}`}
                        groupTitle='silico-pred-tile'
                        priors={variant.priors}
                        displayTitle={<span><i>In Silico</i> Prior Prediction (prior to considering other evidence)</span>}
                        Genomic_Coordinate_hg38={variant.Genomic_Coordinate_hg38}
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        hideEmptyItems={this.state.hideEmptyItems}
                        relayoutGrid={this.relayoutGrid}
                        helpSection="in-silico-prior-probabilities-of-pathogenicity"
                        showHelp={this.showHelp}
                        synonymous={variant.HGVS_Protein.includes('=')}
                    />
                );
            }

            if (groupTitle === "Functional Assay Results") {
                const results = {
                    Biwas: variant.Result_Biwas_ENIGMA_BRCA12_Functional_Assays,
                    Bouwman1: variant.Result_Bouwman1_ENIGMA_BRCA12_Functional_Assays,
                    Bouwman2: variant.Result_Bouwman2_ENIGMA_BRCA12_Functional_Assays,
                    Fernandes: variant.Result_Fernandes_ENIGMA_BRCA12_Functional_Assays,
                    Findlay: variant.Result_Findlay_ENIGMA_BRCA12_Functional_Assays,
                    Ikegami: variant.Result_Ikegami_ENIGMA_BRCA12_Functional_Assays,
                    Mesman: variant.Result_Mesman_ENIGMA_BRCA12_Functional_Assays,
                    Petitalot: variant.Result_Petitalot_ENIGMA_BRCA12_Functional_Assays,
                    Richardson: variant.Result_Richardson_ENIGMA_BRCA12_Functional_Assays,
                    Starita: variant.Result_Starita_ENIGMA_BRCA12_Functional_Assays
                };

                return (
                    <FunctionalAssayTile
                        key={`tile-${groupTitle}`}
                        groupTitle='functional-assay-tile'
                        results={results}
                        displayTitle="Functional Assay Results"
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        hideEmptyItems={this.state.hideEmptyItems}
                        relayoutGrid={this.relayoutGrid}
                        helpSection="functional-assay-results"
                        showHelp={this.showHelp}
                        tooltips={this.state.tooltips}
                        variant={variant}
                        innerGroups={innerGroups}
                    />
                );
            }

            if (groupTitle === "Computational Predictions") {
                return (
                    <ComputationalPredictionTile
                        key={`tile-${groupTitle}`}
                        groupTitle='functional-assay-tile'
                        displayTitle="Computational Predictions"
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        hideEmptyItems={this.state.hideEmptyItems}
                        relayoutGrid={this.relayoutGrid}
                        helpSection="computational-predictions"
                        showHelp={this.showHelp}
                        tooltips={this.state.tooltips}
                        variant={variant}
                        innerGroups={innerGroups}
                    />
                );
            }

            if (groupTitle === "ACMG Variant Evidence Codes, Provisional Assignment") {
                return (
                    <ProvisionalEvidenceTile
			key={`tile-${groupTitle}`}
                        groupTitle={groupTitle}
                        onChangeGroupVisibility={this.onChangeGroupVisibility}
                        relayoutGrid={this.relayoutGrid}
                        helpSection="acmg-variant-evidence-codes-provisional-assignment"
                        showHelp={this.showHelp}
                        variant={variant}
                        innerGroups={innerGroups}
                    />
                );
            }

            // standard 2-column table tile
            const rows = _.map(innerCols, (rowDescriptor, idx) => {
                let {prop, title, noHelpLink} = rowDescriptor;
                let rowItem;

                if (prop === "Protein_Change") {
                    title = "Abbreviated AA Change";
                }

                if (prop === "Mupit_Structure") {
                    rowItem = <MupitStructure variant={variant} prop={prop} onLoad={() => this.relayoutGrid()} />;
                    /*
                    Don't display mupit structures if they don't have an associated Amino Acid change.
                    Note that there shouldn't be mupit structures for these variants in the first place,
                    but there may be as getAminoAcidCode may change after the database is populated
                    */
		    if (util.getAminoAcidCode(variant["HGVS_Protein"]) === false) {
                        rowsEmpty += 1;
                        rowItem = false;
                    }
                    if (rowItem === false) {
                        return false;
                    }
                    if (!variant[prop]) {
                        rowsEmpty += 1;
                        return false;
                    }
                } else if (prop === "HGVS_Protein_ID" && variant["HGVS_Protein"] !== null) {
                    let val = variant["HGVS_Protein"].split(":")[0];
                    variant[prop] = val;
                    rowItem = val;
                } else if (variant[prop] !== null) {
                    rowItem = util.getFormattedFieldByProp(prop, variant);
                }

                let isEmptyValue = (rowDescriptor.replace || rowDescriptor.dummy)
                    ? rowItem === false
                    : util.isEmptyField(variant[prop]);

                if (title === "Beacons") {
                    if (variant.Ref.length > 1 || variant.Alt.length > 1) {
                        isEmptyValue = true;
                    } else {
                        let websiteUrl = `https://beacon-network.org/#/search?chrom=${variant.Chr}&pos=${variant.Hg37_Start}&ref=${variant.Ref}&allele=${variant.Alt}&rs=GRCh37`;
                        rowItem = <a target="_blank" href={websiteUrl} rel="noreferrer">{websiteUrl}</a>;
                        isEmptyValue = false;
                    }
                }

                if (!isEmptyValue && prop === "CA_ID") {
                    let websiteUrl = `http://reg.clinicalgenome.org/redmine/projects/registry/genboree_registry/by_canonicalid?canonicalid=${variant.CA_ID}`;
                    rowItem = <a target="_blank" href={websiteUrl} rel="noreferrer">{variant[prop]}</a>;
                    isEmptyValue = false;
                }

                if (isEmptyValue) {
                    rowsEmpty += 1;
                    rowItem = '-';
                }

                // Make sure keys are unique within each tile table.
                // `prop` alone can collide or be undefined in some cases.
                const rowKey = `vd-${groupTitle}-${prop || idx}`;

                return (
                    <tr key={rowKey} className={ (isEmptyValue && this.state.hideEmptyItems) ? "variantfield-empty" : "" }>
                        { rowDescriptor.tableKey !== false &&
                            (<KeyInline
                                tableKey={title} noHelpLink={noHelpLink}
                                tooltip={this.state.tooltips && prop && this.state.tooltips[slugify(prop)]}
                                onClick={(event) => this.showHelp(event, prop)}
                            />)
                        }
                        <td colSpan={rowDescriptor.tableKey === false ? 2 : null} ><span className={ this.truncateData(prop) ? "row-value-truncated" : "row-value" }>{rowItem}</span></td>
                    </tr>
                );
            });

            const allEmpty = rowsEmpty >= rows.length;
            const tileTable = (
                <Table>
                    <tbody>
                        {rows}
                    </tbody>
                </Table>
            );

            const storageKey = "collapse-group_" + groupTitle;
            const isOpen = this.isGroupOpenLS(storageKey);

            return (
                <div key={`group_collection-${groupTitle}`} className={ (allEmpty && this.state.hideEmptyItems) || (allEmpty && groupTitle === 'CRAVAT - MuPIT 3D Protein View') ? "group-empty" : "" }>
                    <Card className="shadow">
                        <Card.Header
                            role="button"
                            aria-expanded={isOpen}
                            className="d-flex justify-content-between align-items-center"
                            onClick={(event) => { event.preventDefault(); this.toggleCard(storageKey); }}
                        >
                            <span className="title fw-bold">{groupTitle}</span>
                            <span className="d-flex align-items-center">
                                <GroupHelpButton onClick={(event) => { this.showHelp(event, groupTitle); return true; }} />
                            </span>
                        </Card.Header>
                        <Collapse in={isOpen} onEntered={this.relayoutGrid} onExited={this.relayoutGrid}>
                            <div>
                                <Card.Body>
                                    {tileTable}
                                </Card.Body>
                            </div>
                        </Collapse>
                    </Card>
                </div>
            );
        });

        // generates variant diff rows
        const diffRows = this.generateDiffRows(cols, data, false);

        // generates report diff rows
        if (this.state.reports !== undefined) {
            let sortedSubmissions = {'ClinVar': {}, 'LOVD': {}};

            if (Object.prototype.hasOwnProperty.call(this.state.reports, 'ClinVar')) {
                let clinvarSubmissions = this.state.reports.ClinVar;
                for (var i = 0; i < clinvarSubmissions.length; i++) {
                    if (clinvarSubmissions[i].Diff === null || clinvarSubmissions[i].Diff === undefined) {
                        continue;
                    }
                    let key = clinvarSubmissions[i].SCV_ClinVar;
                    if (Object.prototype.hasOwnProperty.call(sortedSubmissions.ClinVar, key)) {
                        sortedSubmissions.ClinVar[key].push(clinvarSubmissions[i]);
                    } else {
                        sortedSubmissions.ClinVar[key] = [clinvarSubmissions[i]];
                    }
                }
            }

            if (Object.prototype.hasOwnProperty.call(this.state.reports, 'LOVD')) {
                let lovdSubmissions = this.state.reports.LOVD;
                for (var j = 0; j < lovdSubmissions.length; j++) {
                    if (lovdSubmissions[j].Diff === null || lovdSubmissions[j].Diff === undefined) {
                        continue;
                    }
                    let key = lovdSubmissions[j].Submission_ID_LOVD;
                    if (Object.prototype.hasOwnProperty.call(sortedSubmissions.LOVD, key)) {
                        sortedSubmissions.LOVD[key].push(lovdSubmissions[j]);
                    } else {
                        sortedSubmissions.LOVD[key] = [lovdSubmissions[j]];
                    }
                }
            }

            var clinvarDiffRows = _.map(sortedSubmissions.ClinVar, function(submissions, key) {
                let newestSubmission = submissions ? submissions[0] : '';
                let oldestSubmission = submissions ? submissions[submissions.length - 1] : '';
                const significance = util.sentenceCase(util.getFormattedFieldByProp("Clinical_Significance_ClinVar", newestSubmission)
                .replace(/(variant of unknown significance|uncertain significance)/i, 'VUS'));
                const submitter = util.abbreviatedSubmitter(util.getFormattedFieldByProp("Submitter_ClinVar", newestSubmission));
                return (
                    <Row key={`clinvar-${key}`}>
                        <Col md={12} className="variant-history-col">
                            <h3>ClinVar Submission: {newestSubmission["SCV_ClinVar"]} ({submitter}; {significance})</h3>
                            <h4>Previous Versions of this Submission (since {util.reformatDate(oldestSubmission.Data_Release.date)}):</h4>
                            <Table className='variant-history nopointer' responsive bordered>
                                <thead>
                                    <tr className='table-active'>
                                        <th>Release Date</th>
                                        <th>Clinical Significance</th>
                                        <th>Changes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.generateDiffRows(cols, submissions, true)}
                                </tbody>
                            </Table>
                            <p style={{display: this.props.mode === "research_mode" ? 'none' : 'block' }}>There may be additional changes to this variant, click &quot;Show Detail View for this Variant&quot; to see these changes.</p>
                        </Col>
                    </Row>
                );
            }, this);

            var lovdDiffRows = _.map(sortedSubmissions.LOVD, function(submissions, key) {
                let newestSubmission = submissions ? submissions[0] : '';
                let oldestSubmission = submissions ? submissions[submissions.length - 1] : '';
                const significance = util.sentenceCase(util.getFormattedFieldByProp("Classification_LOVD", newestSubmission)
                .replace(/(variant of unknown significance|uncertain significance)/i, 'VUS'));
                const submitter = util.abbreviatedSubmitter(util.getFormattedFieldByProp("Submitters_LOVD", newestSubmission));
                return (
                    <Row key={`lovd-${key}`}>
                        <Col md={12} className="variant-history-col">
                            <h3>LOVD Submission: {newestSubmission["DBID_LOVD"]} ({submitter}; {significance})</h3>
                            <h4>Previous Versions of this Submission (since {util.normalizeDateFieldDisplay(oldestSubmission.Data_Release.date)}):</h4>
                            <Table className='variant-history nopointer' responsive bordered>
                                <thead>
                                    <tr className='table-active'>
                                        <th>Release Date</th>
                                        <th>Clinical Significance</th>
                                        <th>Changes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.generateDiffRows(cols, submissions, true)}
                                </tbody>
                            </Table>
                            <p style={{display: this.props.mode === "research_mode" ? 'none' : 'block' }}>There may be additional changes to this variant, click &quot;Show Detail View for this Variant&quot; to see these changes.</p>
                        </Col>
                    </Row>
                );
            }, this);
        }

        const tileSizeClasses = groupTables.length < 3
            ? `col-xs-12 col-md-${12 / groupTables.length}`
            : `col-xs-12 col-md-6 col-lg-6 col-xl-4`;
        const splicingTileSizeClassse = 'col-xs-12 col-md-12 col-lg-12 col-xl-8';

        // splicing panel open state
        const splicingKey = "collapse-group_transcript-visualization";
        const splicingOpen = this.isGroupOpenLS(splicingKey);

        return (error ? <p>{error}</p> :
            <Grid>
                <Row>
                    {
                        (this.props.mode !== "research_mode")
                            ? (
                                <>
                                    <Col lg={2}>
                                        <h3>Variant Details</h3>
                                    </Col>
                                    <Col lg={8} className="vcenterblock">
                                        <div className='text-center Variant-detail-title' style={{textAlign: 'center'}}>
                                            <h1 style={{marginTop: 30}}>{variant.Genomic_HGVS_38 ? variant.Genomic_HGVS_38 : variant.Genomic_Coordinate_hg38}</h1>
                                            <div><i>or</i></div>
                                            <h3 style={{marginTop: 10}}>
                                                {variant['Reference_Sequence']}(<i>{variant['Gene_Symbol']}</i>){`:${variant['HGVS_cDNA'].split(":")[1]}`}
                                                {
                                                    (variant['HGVS_Protein'] && variant['HGVS_Protein'] !== "None") &&
                                                        " " + variant['HGVS_Protein'].split(":")[1]
                                                }
                                            </h3>
                                        </div>
                                    </Col>
                                </>
                            )
                            : (
                                <Col xs={4} sm={{ span: 4, offset: 4 }} md={{ span: 4, offset: 4 }} className="vcenterblock">
                                    <div className='text-center Variant-detail-title'>
                                        <h3>Variant Details</h3>
                                    </div>
                                </Col>
                            )
                    }
                    <Col lg={2} xs={12} className={`d-flex align-items-end ${(this.props.mode !== "research_mode") ? "vlowerblock" : "vcenterblock"}`}>
                        <div className="Variant-detail-headerbar">
                            <Button
                                onClick={this.setEmptyRowVisibility.bind(this, !this.state.hideEmptyItems)}
                                variant="secondary"
				className="text-nowrap">
                                { this.state.hideEmptyItems ?
                                    <span>Show Empty Items</span> :
                                    <span>Hide Empty Items</span>
                                }
                            </Button>
                        </div>
                    </Col>

                    {variant['Change_Type'] === 'deleted' &&
                        (<Col xs={12} className="vcenterblock">
                            <p className='variant-message deleted-variant-message'>
                            Note: This variant has been removed from the BRCA Exchange. For reasons on why this variant was removed please see the <Link to={`/release/${release.id}`}>release notes</Link>.
                            </p>
                        </Col>)
                    }

                    {
                        (variant.id !== data[0].id && noRedirectMsg !== "true") && (
                          <Col xs={12} className="vcenterblock">
                              <div className="variant-message outdated-variant-message alert alert-danger">
                                  <h3 style={{marginTop: 0}}>There is new data available on this variant.</h3>
                                  The data below is from {util.reformatDate(variant.Data_Release.date)} (Release {variant.Data_Release.name}). <a href={`/variant/${data[0].CA_ID}`}>Click here for updated data on this variant.</a>
                              </div>
                          </Col>
                        )
                    }

                    {
                        redirectedFromVariant && (
                          <Col xs={12} className="vcenterblock">
                              <div className="variant-message redirected-variant-msg alert alert-primary">
                                  <h3 style={{marginTop: 0}}>You are viewing the most recent data on this variant.</h3>
                                  The variant url you requested only has data up to {util.reformatDate(redirectedFromVariant.Data_Release.date)}. You have been automatically redirected to the newest data.<br />
                                  <a href={`/variant/${redirectedFrom}?noRedirect=true`}>
                                      Click here to view variant data from {util.reformatDate(redirectedFromVariant.Data_Release.date)} (Release {redirectedFromVariant.Data_Release.name}).
                                  </a>
                              </div>
                          </Col>
                        )
                    }
                </Row>

                <Row>
                    <div className="container-fluid variant-details-body">
                        <IsoGrid ref={ (me) => { this.isogrid = me; } }>
                            <div className={`isogrid-sizer ${tileSizeClasses}`} />

                            {
                                this.props.mode === "research_mode" && (
                                    <Col key="splicing_vis"
                                        className={`variant-detail-group isogrid-item ${splicingTileSizeClassse} p-2`}>
                                        <Card className="shadow">
                                            <Card.Header
                                                role="button"
                                                aria-expanded={splicingOpen}
                                                className="d-flex justify-content-between align-items-center"
                                                onClick={(e) => { e.preventDefault(); this.toggleCard(splicingKey); }}
                                            >
                                                <span className="title fw-bold">{`${variant['Gene_Symbol']} ${variant['HGVS_cDNA']} Transcript Visualization`}</span>
                                                <span className="d-flex align-items-center">
                                                    <GroupHelpButton group={"transcript-visualization"} onClick={(event) => { this.showHelp(event, "transcript-visualization"); return true; }} />
                                                </span>
                                            </Card.Header>
                                            <Collapse in={splicingOpen} onEntered={this.relayoutGrid} onExited={this.relayoutGrid}>
                                                <div>
                                                    <Card.Body>
                                                        <Splicing variant={variant} relayoutGrid={this.relayoutGrid} />
                                                    </Card.Body>
                                                </div>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                )
                            }

                            {
                                groupTables.map((x, i) => {
                                    return (
                                        <Col key={"group_col-" + i}
                                            className={`variant-detail-group isogrid-item ${tileSizeClasses} p-2`}>
                                            {x}
                                        </Col>
                                    );
                                })
                            }
                        </IsoGrid>
                    </div>
                </Row>

                <Row>
                    <Col md={12} className="variant-history-col">
                        <h3>
                            {variant['Reference_Sequence']}(<i>{variant['Gene_Symbol']}</i>){`:${variant['HGVS_cDNA'].split(":")[1]}`}
                            {
                                (variant['HGVS_Protein'] && variant['HGVS_Protein'] !== "None") &&
                                " " + variant['HGVS_Protein'].split(":")[1]
                            }
                        </h3>
                    </Col>
                </Row>

                { this.props.mode === "research_mode" && (
                    <Row>
                        <Col md={12} className="variant-literature-col">
                            <LiteratureTable maxRows={10} variant={variant} hideEmptyItems={this.state.hideEmptyItems} />
                        </Col>
                    </Row>
                    )
                }

                <Row>
                    <Col md={12} className="variant-history-col">
                        <h4>Variant History:</h4>
                        <p>Variant nomenclature may change between releases, please review submission history below for further details.</p>
                        <Table className='variant-history nopointer' responsive bordered>
                            <thead>
                                <tr className='table-active'>
                                    <th>Release Date</th>
                                    <th>Clinical Significance</th>
                                    <th>Changes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {diffRows}
                            </tbody>
                        </Table>
                        <p style={{display: this.props.mode === "research_mode" ? 'none' : 'block' }}>There may be additional changes to this variant, as well as changes to corresponding submissions. Click &quot;Show Detail View for this Variant&quot; to see these changes.</p>
                    </Col>
                </Row>

                {this.props.mode === "research_mode" ? clinvarDiffRows : ''}
                {this.props.mode === "research_mode" ? lovdDiffRows : ''}

                <Row>
                    <Col md={{ span: 12, offset: 0 }}>
                        <DisclaimerModal buttonModal onToggleMode={this.props.toggleMode} text="Show Detail View for this Variant"/>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

class Application extends React.Component {
    constructor(props) {
	super(props);
	this.state = {
	    mode: localStorage.getItem('research-mode') === 'true' ? 'research_mode' : 'default',
	};
    }

	onChildToggleMode = () => {
        this.toggleMode();
    };

    componentDidUpdate() {
        const localStorageMode = localStorage.getItem("research-mode") === "true" ? "research_mode" : "default";
        if (localStorageMode !== this.state.mode) {
            this.setMode();
        }
    }

    setMode = () => {
        this.setState({mode: localStorage.getItem("research-mode") === 'true' ? 'research_mode' : 'default'});
    };

    toggleMode = () => {
        console.log('toggleMode called, current mode:', this.state.mode);
    	if (this.state.mode === 'research_mode') {
            localStorage.setItem('research-mode', false);
            this.setState({mode: 'default'}, () => {
               console.log('State updated to:', this.state.mode);
            });
    	} else {
            localStorage.setItem('research-mode', true);
            this.setState({mode: 'research_mode'}, () => {
            	console.log('State updated to:', this.state.mode);
            });
    	}
    };

    render() {
        const path = (this.props.location && this.props.location.pathname ? this.props.location.pathname : '/').slice(1);
        return (
            <div>
                <NavBarNew path={path} mode={this.state.mode} toggleMode={this.toggleMode}/>
                <DonationBar />
                {/* If children are rendered here via a parent Route, pass props along */}
         	{this.props.children &&
           		React.Children.map(this.props.children, child => {
			    if (React.isValidElement(child)) {
				return React.cloneElement(child, {
             			   toggleMode: this.onChildToggleMode,
             			   mode: this.state.mode,
				});
			    }
			    return child;
           	})}
		{path.indexOf('variants') === 0 && (
		<Database
		    location={this.props.location}
		    history={this.props.history}
                    mode={this.state.mode}
                    toggleMode={this.onChildToggleMode}
                    show={path.indexOf('variants') === 0} />
		)}
		{path.indexOf('variant/') === 0 && (() => {
		const variantId = path.split('variant/')[1]?.split('?')[0]?.split('#')[0];
    		console.log('Rendering VariantDetail from Application, mode:', this.state.mode, 'id:', variantId);
    		return (
        	<VariantDetail
            	location={this.props.location}
            	history={this.props.history}
            	match={{ params: { id: variantId } }}
            	params={{ id: variantId }}
            	mode={this.state.mode}
            	toggleMode={this.onChildToggleMode}
       		/>
	       	);
	    	})()}
                <Footer />
            </div>
        );
    }
}

// Wrap Application with withRouter so it gets location/history props
const ApplicationWithRouter = withRouter(Application);

const routes = (
    <Switch>
        <Route exact path='/' component={Home}/>
	<Route path='/about/:page' component={About}/>
	<Route path='/community' component={Community}/>
	<Route path='/help' component={Help}/>
	<Route path='/factsheet' component={FactSheet}/>
	<Route path='/releases' component={Releases}/>
        <Route path='/release/:id' component={Release}/>
        <Route path='/whydonate' component={WhyDonate}/>
        <Route path='/fundraisingdetails' component={FundraisingDetails}/>
	{/*<Route path='/variant/:id' component={VariantDetail}/>*/}
        <Route path='/variant_literature/:id' component={LiteratureTable}/>
        <Route path='/signup' component={Signup}/>
        <Route path='/signin' component={Signin}/>
        <Route path='/reset_password' component={ResetPassword}/>
	<Route path='/profile' component={Profile}/>
        <Route path='/confirm/:activationCode' component={ConfirmEmail}/>
	<Route path='/reset/:resetToken' component={ChangePassword}/>
	<Route path='/resources' component={Resources}/>
    </Switch>
);

const container = document.getElementById('main');
const root = createRoot(container);
root.render(
    <BrowserRouter>
	<ApplicationWithRouter>
		{routes}
	</ApplicationWithRouter>
    </BrowserRouter>
);
